import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { IProduct } from "./products.interface";
import { HttpService } from "../../../../http.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { apiURL, EnvConfig } from "../../../../env-config";

@Injectable()
export class ProductsService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
  ) { }

  getProducts(filter?: any): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_PRODUCTS)}${queryParams}`);
  }

  getProduct(product: IProduct | string): Observable<any> {
    let id = (typeof product == 'string') ? product : product._id;
    return this._http.get(`${apiURL(EnvConfig.API_PRODUCTS)}/${id}`);
  }

  createProduct(product: IProduct): Observable<any> {
    return this._http.post(`${apiURL(EnvConfig.API_PRODUCTS)}`, product);
  }

  updateProduct(product: IProduct): Observable<any> {
    let id = product._id;
    delete product._id;
    return this._http.patch(`${apiURL(EnvConfig.API_PRODUCTS)}/${id}`, product);
  }

  deleteProduct(product: IProduct | string, hardDelete: boolean = false): Observable<void> {
    let id = (typeof product == 'string') ? product : product._id;
    if (hardDelete) return this._http.delete(`${apiURL(EnvConfig.API_PRODUCTS)}/${id}`);
    return this._http.delete(`${apiURL(EnvConfig.API_PRODUCTS)}/${id}/delete`);
  }

  restoreProduct(product: IProduct | string): Observable<void> {
    let id = (typeof product == 'string') ? product : product._id;
    return this._http.post(`${apiURL(EnvConfig.API_PRODUCTS)}/${id}/restore`, null);
  }

  export(query: any) {
    let queryParams: string = '?' + this._utilsService.toQueryString(query);
    this._http.get(`${apiURL(EnvConfig.API_PRODUCTS)}/export/${queryParams}`, { responseType: "arraybuffer" }).subscribe(file => {
      this._utilsService.blobToFile(file, "application/xlsx", 'tarifas-' + new Date().getTime() + '.xlsx');
    });
  }
}